import React from 'react';

const AnuncioWhatsAppTailwind = ({ adData, userMessage }) => {
  if (!adData) {
    return null;
  }

  const domain = new URL(adData.source_url).hostname;

  // Función para limitar el texto del cuerpo del anuncio
  const truncateText = (text, maxLength = 100) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    // Corta el texto y añade puntos suspensivos
    return text.substring(0, maxLength) + '...';
  };

  const truncatedBody = truncateText(adData.body_ad, 90); // Limitar a 90 caracteres

  // Formato de la hora
  const formatTime = (date) => {
    if (!date) return '';
    const options = { hour: 'numeric', minute: 'numeric', hour12: true };
    return new Date(date).toLocaleTimeString('es-ES', options);
  };


  return (
    <div className="flex flex-col items-start max-w-[450px] space-y-2">
      {/* Contenedor del anuncio (tarjeta) */}
      <a 
        href={adData.source_url} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="no-underline text-inherit inline-block w-full"
      >
        <div className="bg-[#2a3942] border border-[#3a4b53] rounded-lg overflow-hidden cursor-pointer transition-colors duration-200 hover:bg-[#30414b] w-full">
          
          {/* La imagen del anuncio (arriba y centrada) */}
          {adData.image_url && ( // Solo muestra la imagen si existe una URL
            <img 
              src={adData.image_url} 
              alt={adData.headline} 
              className="w-full h-auto object-cover max-h-[180px] rounded-t-lg" // Ancho completo, altura automática
            />
          )}
          
          {/* El contenido de texto del anuncio */}
          <div className="p-3 flex flex-col text-white">
            <h3 className="font-semibold text-sm mb-1 text-white leading-tight">
              {truncateText(adData.headline, 60)} {/* También cortamos el headline */}
            </h3>
            
            <p className="text-xs opacity-75 whitespace-pre-wrap leading-tight mb-1">
              {truncatedBody}
            </p>

            <span className="text-[0.65rem] opacity-50 mt-1">
              {domain}
            </span>
          </div>
        </div>
      </a>

      {/* Mensaje del usuario */}
      {userMessage}

    </div>
  );
};

export default AnuncioWhatsAppTailwind;